// extracted by mini-css-extract-plugin
export default {"container":"inputField_container__X-iDx","title":"inputField_title__BkEC6","redStar":"inputField_redStar__dXiPo"};